/**
 * Api Ia Service
 * Api client pour Lauria
 *
 * Class générée manuellement
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface IaServicesAskRead
 */
export interface IaServicesAskRead {

    /**
     * 
     * @type {string}
     * @memberof IaServicesAskRead
     */
    'answer'?: string;
    /**
     * 
     * @type {string}
     * @memberof IaServicesAskRead
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof IaServicesAskRead
     */
    'message_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof IaServicesAskRead
     */
    'guid'?: string;
}

/**
 * 
 * @export
 * @interface PostIaServicesAskRequest
 */
export interface PostIaServicesAskRequest {
    /**
     * Application Lauria
     * @type {string}
     * @memberof PostIaServicesAskRequest
     */
    'application'?: string;

    /**
    * Paramètres
    * @type {object}
    * @memberof PostIaServicesAskRequest
    */
    'params'?: object;

    /**
     * Documents
     * @type {string}
     * @memberof PostIaServicesAskRequest
     */
    'documents'?: string;
}
/**
 * IaService - axios parameter creator
 * @export
 */
export const IaServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ask question to llm
         * @summary Pose une simple question au llm
         * @param {PostIaServicesAskRequest} PostIaServicesAskRequest Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIaServicesAsk: async (PostIaServicesAskRequest: PostIaServicesAskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'PostIaServicesAskRequest' is not null or undefined
            assertParamExists('PostIaServicesAskRequest', 'PostIaServicesAskRequest', PostIaServicesAskRequest)
            const localVarPath = `/iaservices/v1/ask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)



            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PostIaServicesAskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IaServices - functional programming interface
 * @export
 */
export const IaServicesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = IaServiceApiAxiosParamCreator(configuration)
    return {
        /**
          * Ask question to llm
          * @summary Pose une simple question au llm
          * @param {PostIaServicesAskRequest} postIaServicesAskRequest Request body
          * @param {*} [options] Override http request option.
          * @throws {RequiredError}
          */
        async apiIaServicesAsk(postIaServicesAskRequest: PostIaServicesAskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IaServicesAskRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIaServicesAsk(postIaServicesAskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IaService.apiIaServiceAsk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IaService - factory interface
 * @export
 */
export const IaServicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IaServicesApiFp(configuration)
    return {
        /**
         * Ask question to llm
        * @summary Pose une simple question au llm
        * @param {PostIaServicesAskRequest} requestParameters Request parameters.
        * @param {*} [options] Override http request option.
        * @throws {RequiredError}
        */
        apiIaServicesAsk(requestParameters: PostIaServicesAskRequest, options?: RawAxiosRequestConfig): AxiosPromise<IaServicesAskRead> {
            return localVarFp.apiIaServicesAsk(requestParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AcomptesApi - object-oriented interface
 * @export
 * @class AcomptesApi
 * @extends {BaseAPI}
 */
export class IaServicesApi extends BaseAPI {
    /**
      * Ask question to llm
     * @summary Pose une simple question au llm
     * @param {PostIaServicesAskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcomptesApi
     */
    public apiIaServiceAsk(requestParameters: PostIaServicesAskRequest, options?: RawAxiosRequestConfig) {
        return IaServicesApiFp(this.configuration).apiIaServicesAsk(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


